import { StoreState } from 'app/app.reducers';

export const getRequestTutoringFlowCurrIdx = (state: StoreState) =>
  state.requestTutoring.requestTutoringCurrIdx;

export const getRequestTutoringFlow = (state: StoreState) =>
  state.requestTutoring.requestTutoringFlow;
